import { Cookies } from "react-cookie";

export class CookieStorage {
  _storage = new Cookies(null);

  get(key: string): string | null;
  get(key: string, type: StringConstructor): string | null;
  get(key: string, type: NumberConstructor): number | null;
  get(key: string, type?: StringConstructor | NumberConstructor): string | number | null {
    const item = this._storage.get<string>(key);

    if (!item) {
      return null;
    }

    if (!type || type === String) {
      return item;
    }

    return JSON.parse(item);
  }
}
